import logo from '../../assets/logo.png'
const FallbackLoading = () => {
  return (
    <div className="flex flex-col space-y-5 justify-center items-center h-screen">
      <img src={logo} height={80} width={80} alt="Logo" />
      <div className="animate-spin rounded-full h-14 w-14 border-t-4 border-b-4 border-bleu_text"></div>
    </div>
  );
};

export default FallbackLoading;